import { h } from 'preact';
import StockInfoTable from '../stock-info-table';
import style from './style';

const WorldMarkets = () => (
	<div class={style['world-markets']}>
		<StockInfoTable
			columns={['symbol', 'price', 'change']}
			symbols={['$FTSE', '$PARI', '$DAX', '$N225', '$HSI', '$AOI', 'TSX:0000']}
			cursor={0}
		/>
	</div>
);

export default WorldMarkets;
